module.exports = __webpack_public_path__ + "static/media/pseudochorthippus_parallelus.0d74c803.jpg";